import {FeedbacksData} from '../../typedef';

export const userRole = (state: Selector) => state.authenticated.roles;

export const getTeamData = (state: Selector) => state.qualityFeedbackReducer.teamData;

export const getOptionalData = (state: Selector) => state.qualityFeedbackReducer.optionalData;

interface Selector {
    qualityFeedbackReducer: {
        teamData: FeedbacksData[];
        optionalData: FeedbacksData[];
    };
    authenticated: {
        roles: string[];
    };
}
